import { setModalShown } from './util';
import Modal from '@common/vanilla_ui/general/modal';
import { EVENTS_FORM_VARIANTS, EVENTS_FORM_IDS } from './constant';

const MODAL_ID = 'rcb-exit-intent-modal';

const checkFormAndShowModal = (formId) => {
  try {
    const formEl = document.getElementById(formId);
    if (!formEl) return;

    const selectInputEls = formEl.querySelectorAll(
      'input.sr-select__value-input:not([name="phone_country_code"])',
    ) || [];
    const formInputEls = formEl.querySelectorAll('input.form-input') || [];
    const inputs = [...selectInputEls, ...formInputEls];

    const isAnyInputFilled = inputs.some((input) => input.value.trim() !== '');

    if (!isAnyInputFilled) {
      Modal.open(MODAL_ID, true);
      setModalShown();
    }
  } catch (error) {
    window.GTMtracker?.pushEvent({
      event: 'gtm_custom_click',
      data: {
        click_type: 'rcb-exit-intent-modal-err',
        click_text: `${error}`,
      },
    });
  }
};

export function eventsTrigger() {
  const modalElement = document.getElementById(MODAL_ID);
  if (!modalElement) return;

  const rootEl = document.getElementById('root');
  const formVariant = rootEl?.getAttribute('data-variant-value');

  if (EVENTS_FORM_VARIANTS.DEFAULT.includes(formVariant)) {
    checkFormAndShowModal(EVENTS_FORM_IDS.DEFAULT);
  }

  if (EVENTS_FORM_VARIANTS.UNIFIED_AUTH.includes(formVariant)) {
    checkFormAndShowModal(EVENTS_FORM_IDS.UNIFIED_AUTH);
  }
}
